/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';

import ErrorBoundary from '../components/ErrorBoundary';

const withErrorBoundary = (Component) => {
  function WrappedComponent (props) {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  }

  WrappedComponent.displayName = `withErrorBoundary(${ Component.displayName || Component.name || 'Component' })`;

  return WrappedComponent;
};

export default withErrorBoundary;
